export const SELL_AND_PURCHASE_LOADING = 'SELL_AND_PURCHASE_LOADING';
export const SELL_AND_PURCHASE_SUCCESS = 'SELL_AND_PURCHASE_SUCCESS';
export const SELL_AND_PURCHASE_ERROR = 'SELL_AND_PURCHASE_ERROR';
export const SELL_AND_PURCHASE_CLEAR_ERROR = 'SELL_AND_PURCHASE_CLEAR_ERROR';
export const SELL_AND_PURCHASE_CLEAR_REDUCER = 'SELL_AND_PURCHASE_CLEAR_REDUCER';

export const SELL_AND_PURCHASE_INITIATE_APPLICATION = 'SELL_AND_PURCHASE_INITIATE_APPLICATION';
export const SELL_AND_PURCHASE_FETCH_APPLICATION_DETAILS = 'SELL_AND_PURCHASE_FETCH_APPLICATION_DETAILS';
export const SELL_AND_PURCHASE_FETCH_PROPERTY = 'SELL_AND_PURCHASE_FETCH_PROPERTY';
export const SELL_AND_PURCHASE_FETCH_DOCUMENTS = 'SELL_AND_PURCHASE_FETCH_DOCUMENTS';

export const SELL_AND_PURCHASE_SAVE_UPDATED_OWNERS = 'SELL_AND_PURCHASE_SAVE_UPDATED_OWNERS';

export const SELL_AND_PURCHASE_SAVE_UPDATED_BUYERS = 'SELL_AND_PURCHASE_SAVE_UPDATED_BUYERS';

export const SELL_AND_PURCHASE_CHANGE_BUYER_TRANSACTION_SHARE = 'SELL_AND_PURCHASE_CHANGE_BUYER_TRANSACTION_SHARE';
export const SELL_AND_PURCHASE_CHANGE_OWNER_TRANSACTION_SHARE = 'SELL_AND_PURCHASE_CHANGE_OWNER_TRANSACTION_SHARE';

export const SELL_PURCHASE_FETCH_BREAKDOWN = 'SELL_PURCHASE_FETCH_BREAKDOWN';

// ------------------ previous work -------------------- //

export const INITIATE_SP_APPLICATION = 'INITIATE_SP_APPLICATION';
export const INITIATE_SP_APPLICATION_SUCCESS = 'INITIATE_SP_APPLICATION_SUCCESS';

export const FETCH_SP_WORKFLOW = 'FETCH_SP_WORKFLOW';
export const FETCH_SP_WORKFLOW_SUCCESS = 'FETCH_SP_WORKFLOW_SUCCESS';

export const FETCH_VALIDATION = 'FETCH_VALIDATION';
export const FETCH_VALIDATION_SUCCESS = 'FETCH_VALIDATION_SUCCESS';

export const FETCH_BUYER = 'FETCH_BUYER';
export const FETCH_BUYER_SUCCESS = 'FETCH_BUYER_SUCCESS';

export const FETCH_SP_POA = 'FETCH_SP_POA';
export const FETCH_SP_POA_SUCCESS = 'FETCH_SP_POA_SUCCESS';

export const FETCH_EVALUATION = 'FETCH_EVALUATION';
export const FETCH_EVALUATION_SUCCESS = 'FETCH_EVALUATION_SUCCESS';

export const ADD_BUYER = 'ADD_BUYER';
export const ADD_BUYER_SUCCESS = 'ADD_BUYER_SUCCESS';

export const ADD_SP_POA = 'ADD_SP_POA';
export const ADD_SP_POA_SUCCESS = 'ADD_SP_POA_SUCCESS';

export const DELETE_SP_POA = 'DELETE_SP_POA';
export const DELETE_SP_POA_SUCCESS = 'DELETE_SP_POA_SUCCESS';

export const DOWNLOAD_DOCUMENT = 'DOWNLOAD_DOCUMENT';
export const DOWNLOAD_DOCUMENT_SUCCESS = 'DOWNLOAD_DOCUMENT_SUCCESS';

export const DELETE_BUYER = 'DELETE_BUYER';
export const DELETE_BUYER_SUCCESS = 'DELETE_BUYER_SUCCESS';

export const SAVE_APPLICATION = 'SAVE_APPLICATION';
export const SAVE_APPLICATION_SUCCESS = 'SAVE_APPLICATION_SUCCESS';

export const FETCH_OWNERS = 'FETCH_OWNERS';
export const FETCH_OWNERS_SUCCESS = 'FETCH_OWNERS_SUCCESS';

export const UPLOAD_DOCUMENT = 'UPLOAD_DOCUMENT';
export const UPLOAD_DOCUMENT_SUCCESS = 'UPLOAD_DOCUMENT_SUCCESS';

export const UPLOAD_SP_DOCUMENT = 'UPLOAD_SP_DOCUMENT';
export const UPLOAD_SP_DOCUMENT_SUCCESS = 'UPLOAD_SP_DOCUMENT_SUCCESS';

export const DELETE_DOCUMENT = 'DELETE_DOCUMENT';
export const DELETE_DOCUMENT_SUCCESS = 'DELETE_DOCUMENT_SUCCESS';

export const FETCH_APPLICATION_DETAILS = 'FETCH_APPLICATION_DETAILS';
export const FETCH_APPLICATION_DETAILS_SUCCESS = 'FETCH_APPLICATION_DETAILS_SUCCESS';

export const INITIATE_SP_EDIT = 'INITIATE_SP_EDIT';
export const INITIATE_SP_EDIT_SUCCESS = 'INITIATE_SP_EDIT_SUCCESS';

export const SUBMIT_APPLICATION = 'SUBMIT_APPLICATION';
export const SUBMIT_APPLICATION_SUCCESS = 'SUBMIT_APPLICATION_SUCCESS';

export const DISCARD_SELL_AND_PURCHASE_APPLIATION = 'DISCARD_SELL_AND_PURCHASE_APPLIATION';
export const DISCARD_SELL_AND_PURCHASE_APPLIATION_SUCCESS = 'DISCARD_SELL_AND_PURCHASE_APPLIATION_SUCCESS';

export const ADD_TO_ERROR = 'ADD_TO_ERROR';
export const ADD_TO_ERROR_INITITATE = 'ADD_TO_ERROR_INITITATE';

export const GENERAL_SP_ERROR = 'GENERAL_SP_ERROR';
export const CHANGE_FORM = 'CHANGE_FORM';
export const RESET_BUYER_RESPONSE = 'RESET_BUYER_RESPONSE';
export const CHANGE_SP_WORKFLOW_STEP = 'CHANGE_SP_WORKFLOW_STEP';
export const RESET_SELL_AND_PURCHASE_WORKFLOW = 'RESET_SELL_AND_PURCHASE_WORKFLOW';

export const CHANGE_PERCENTAGE = 'CHANGE_PERCENTAGE';

export const CHANGE_SELLING_DETAIL = 'CHANGE_SELLING_DETAIL';

export const CALCULATE_FEE_SUCCESS = 'CALCULATE_FEE_SUCCESS';

export const CHANGE_APPOINMENT_DETAIL = 'CHANGE_APPOINMENT_DETAIL';

export const UPDATE_WORKING_HOURS = 'UPDATE_WORKING_HOURS';

export const SAVE_APPOINMET_DETAIL = 'SAVE_APPOINMET_DETAIL';

export const ADD_BROKER_SUCCESS = 'ADD_BROKER_SUCCESS';

export const DELETE_BROKER_SUCCESS = 'DELETE_BROKER_SUCCESS';

export const SAVE_SALE_DETAIL = 'SAVE_SALE_DETAIL';

export const CLEAR_ADD_TO_ERROR = 'CLEAR_ADD_TO_ERROR';

export const CHECKOUT_SALE_SUCCESS = 'CHECKOUT_SALE_SUCCESS';

export const UPDATE_ATTENDES_LIST_BUYER = 'UPDATE_ATTENDES_LIST_BUYER';

export const UPDATE_ATTENDES_LIST_SELLER = 'UPDATE_ATTENDES_LIST_SELLER';

export const FETCH_AUDITOR_FLOW_DETAILS_SUCCESS = 'FETCH_AUDITOR_FLOW_DETAILS_SUCCESS';

export const UPDATED_TIME_SLOT = 'UPDATED_TIME_SLOT';

export const IS_SALE_VALUE_UPDATE = 'IS_SALE_VALUE_UPDATE';
